import axios from 'axios';
import { V1API } from '../../../_helpers/APIPath';
import { encode, decode } from '../../dataMagic';
import { populateStore, performNetworkCall, buildFormData } from '@/store/asyncHelper';



const mutations = {};
const store = {};

populateStore(store, mutations, false);

export default {
    namespaced: true,

    state : {

        participants:[],
        reviewers:[],
        group:[],

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        attachmentSubmitLoading: false,
        attachmentSubmitError: false,
        attachmentSubmitSuccess: false,

        participantLoading: false,
        participantError: false,



        ...store
    },

    mutations : {
        ...mutations,

        SET_PARTICPANT(state, fellow) {
            state.participants= fellow;
        },
        SET_REVIEWER(state, fellow) {
            state.reviewers= fellow;
        },
        SET_REVIEW_GROUP(state, fellow) {
            state.group= fellow;
        },
        SET_PARTICPANT_DETAIL(state, detail) {
            state.participant_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },
        SET_ATTACH(state, detail) {
            state.attachment = detail;
        },
        ATTACH_LOADING (state, loading) {
            state.attachmentSubmitLoading = loading;
        },
        ATTACH_SUCCESS (state, success) {
            state.attachmentSubmitSuccess = success;
        },

        ATTACH_ERROR (state, hasError) {
            state.attachmentSubmitError = hasError;
        },


        PARTICPANT_LOADING (state, loading) {
            state.participantLoading = loading;
        },

        PARTICPANT_ERROR (state, hasError) {
            state.participantError = hasError;
        },




    },

    actions: {


        async fetchParticipantList ({ commit }) {
            commit('PARTICPANT_LOADING', true);
            commit('PARTICPANT_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.participant_list, config);
                let response = result.data;

                commit('SET_PARTICPANT', response.data);

            } catch(error) {
                commit('PARTICPANT_ERROR', true);
            } finally {
                commit('PARTICPANT_LOADING', false);
            }
        },
        async fetchGroupList ({ commit }) {
            commit('PARTICPANT_LOADING', true);
            commit('PARTICPANT_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.review_group_list, config);
                let response = result.data;

                commit('SET_REVIEW_GROUP', response.data);

            } catch(error) {
                commit('PARTICPANT_ERROR', true);
            } finally {
                commit('PARTICPANT_LOADING', false);
            }
        },
        async addGroup ({commit, dispatch}, payload) {
            commit('INFO_GRAPHY_LOADING', true);
            commit('INFO_GRAPHY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.review_group_add, payload, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchGroupList')


                return response

            }catch (e) {
                commit('INFO_GRAPHY_ERROR', true);
            }finally {
                commit('INFO_GRAPHY_LOADING', false);
            }
        },
        async updateGroup ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.review_group_edit+payload.id+'/update', payload.payload, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchGroupList')

                return response

            }catch (e) {
                commit('INFO_GRAPHY_ERROR', true);
            }finally {
                commit('INFO_GRAPHY_LOADING', false);
            }
        },

        async deleteGroup({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.review_group_delete+payload.delete+'/delete', config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchGroupList')

            return response
        },


        async fetchReviewerList ({ commit }) {
            commit('PARTICPANT_LOADING', true);
            commit('PARTICPANT_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.reviewer_list, config);
                let response = result.data;

                commit('SET_REVIEWER', response.data);

            } catch(error) {
                commit('PARTICPANT_ERROR', true);
            } finally {
                commit('PARTICPANT_LOADING', false);
            }
        },
         async removeReviewerFromGroup ({ commit, dispatch },payload) {
                    commit('SUBMIT_LOADING', true);
                    commit('SUBMIT_ERROR', false);

                    let config = {
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    };

                    try{
                        let result = await axios.delete(V1API.reviewer_from_group_delete+payload.group+'/remove-reviewer/'+payload.user, config);
                        let response = result.data;
                        dispatch ('fetchReviewerList')
                        return response

                    } catch(error) {
                        commit('SUBMIT_ERROR', true);
                    } finally {
                        commit('SUBMIT_LOADING', false);
                    }
                },
        async addReviewerToGroup ({ commit, dispatch },payload) {
                    commit('SUBMIT_LOADING', true);
                    commit('SUBMIT_ERROR', false);

                    let config = {
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                        }
                    };

                    try{
                        let result = await axios.post(V1API.reviewer_to_group_add,payload, config);
                        let response = result.data;
                        dispatch ('fetchReviewerList')
                        return response

                    } catch(error) {
                        commit('SUBMIT_ERROR', true);
                    } finally {
                        commit('SUBMIT_LOADING', false);
                    }
                },

            async removeSubmissionFromGroup ({ commit, dispatch },payload) {
                                commit('SUBMIT_LOADING', true);
                                commit('SUBMIT_ERROR', false);

                                let config = {
                                    headers: {
                                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                    }
                                };

                                try{
                                    let result = await axios.delete(V1API.submission_from_group_delete+payload.submission+'/group/'+payload.group+'/remove', config);
                                    let response = result.data;
                                    return response

                                } catch(error) {
                                    commit('SUBMIT_ERROR', true);
                                } finally {
                                    commit('SUBMIT_LOADING', false);
                                }
                            },
                    async addSubmissionToGroup ({ commit, dispatch },payload) {
                                commit('SUBMIT_LOADING', true);
                                commit('SUBMIT_ERROR', false);

                                let config = {
                                    headers: {
                                        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                                    }
                                };

                                try{
                                    let result = await axios.post(V1API.submission_to_group_add,payload, config);
                                    let response = result.data;
                                    return response

                                } catch(error) {
                                    commit('SUBMIT_ERROR', true);
                                } finally {
                                    commit('SUBMIT_LOADING', false);
                                }
                            },



        async updateSubmission ({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try {

                let response = await axios.patch(V1API.participant_update_own_participant, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });
                dispatch('fetchMySubmissionDetail');

                commit('SUBMIT_SUCCESS', true);

                return response;

            }catch (e) {
                commit('PARTICPANT_ERROR', true);
            }finally {
                commit('PARTICPANT_LOADING', false);
            }
        },
        async AdminUpdateSubmission ({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try {

                let response = await axios.patch(V1API.participant_update_admin, payload, config).then(result=>{
                    let data = result.data;
                    return data;

                });
                dispatch('fetchSubmissionDetail',response.data.id);

                commit('SUBMIT_SUCCESS', true);

                return response;

            }catch (e) {
                commit('PARTICPANT_ERROR', true);
            }finally {
                commit('PARTICPANT_LOADING', false);
            }
        },

        async fetchAttachmentList ({ commit },payload ) {
            commit('PARTICPANT_LOADING', true);
            commit('PARTICPANT_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.participant_attachment_list+'/'+payload, config);
                let response = result.data;

                commit('SET_ATTACH', response.data);

            } catch(error) {
                commit('PARTICPANT_ERROR', true);
            } finally {
                commit('PARTICPANT_LOADING', false);
            }
        },

        async addAttachment ({commit, dispatch}, payload) {
            commit('ATTACH_LOADING', true);
            commit('ATTACH_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
                "Content-Type": "multipart/form-data"
            };
            try{
                console.log(payload, "payload")
                let data= new FormData()
                let payloadData = buildFormData(data, payload);

                let response = await axios.post(V1API.participant_attachment_upload, payloadData, config).then(result=>{

                    let data = result.data
                    return data

                });

                commit('ATTACH_SUCCESS', true);
                dispatch("fetchAttachmentList",payload.participant)
                return response

            }catch (e) {
                console.log(e)

                commit('ATTACH_ERROR', true);
            }finally {

                commit('ATTACH_LOADING', false);
            }
        },

        async deleteAttachment ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.participant_attachment_delete + payload.id+"/delete", config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchAttachmentList',payload.participant)

            return response
        },
        async updateStatusToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.get(V1API.participant_status_toggle+payload.participant_id, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchSubmissionList');

            return response;
        },























    },

    getters: {}
};
